import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

const ConsultingApprovalModal = (props) => {
    const { handleShowApproveModal, handleAgreeSubmit, showModal } = props;

    return (
        <Dialog aria-labelledby="approval-title" aria-describedby="approval-content" open={showModal}>
            <DialogTitle id="approval-title">Approval Confirmation</DialogTitle>
            <DialogContent id="approval-content">
                All consulting deals require approval from your regional president by clicking okay you acknowledge that
                you have obtained the approval to proceed with creating a consulting deal.
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={() => {
                        handleShowApproveModal(!showModal);
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        handleAgreeSubmit(!showModal);
                    }}
                >
                    Okay
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConsultingApprovalModal;
